import { ThemeConfig } from 'antd'

/**
 * Theme for the content of settings form pages (pages using `usePageOptions({ formTheme: true })`). It is
 * nested inside the app theme, so only the values set here differ from the rest of the app.
 */
export const formPageTheme: ThemeConfig = {
  // Roomier controls than the compact theme the app uses elsewhere: algorithm: theme.defaultAlgorithm
  token: {
    fontSize: 14,
    // Trial font, loaded in public/index.html
    fontFamily: "'Noto Sans', sans-serif"
  }
}
